import { Tooltip, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const EngagementNameCell = React.memo((row: Dashboard) => (
  <>
    {row?.engagement_name && (
      <Tooltip title={`${capitalize(row?.engagement_name)}`}>
        <Typography variant="body2" noWrap>{`${capitalize(row?.engagement_name)}`}</Typography>
      </Tooltip>
    )}
  </>
));

export default EngagementNameCell;
